import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { addFavorite } from '../store/actions/favorite'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

function Card(props) {
  const MySwal = withReactContent(Swal)
  const dispatch = useDispatch()

  function handleAddFavorite(e) {
    e.preventDefault()
    dispatch(addFavorite(props))
    MySwal.fire({
      title: 'Successfully added to favorites!',
      icon: 'success',
      toast: true,
      position: 'top-end',
      type: 'success',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true
    })
  }

  let altText 
 if (props.artwork.thumbnail) {
   altText = props.artwork.thumbnail.alt_text
 } else {
   altText = 'no alt text available'
 }

  return (
    <div className="card card-main">
      <img
        src={props.artwork.imageUrl}
        className="card-img-top img-fluid"
        alt={altText}
      />
      <div className="card-body">
        <h5 className="card-title">{props.artwork.title}</h5>
        {
          props.artwork.artist_title ? 
            <p>{props.artwork.artist_title}</p>
            :
            <p>{props.artwork.artist_display}</p>              
        }
        <Link 
          className="stretched-link"
          to={{ pathname: `/artworks/${props.artwork.id}` }}
        ></Link>
        <div className="row justify-content-center">
          <div className="col-auto" id="add-favorite-button">
            <button
              onClick={handleAddFavorite}
              className="btn btn-success"
            >
              Add to favorites
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Card